import {
  Badge,
  Box,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import CustomBreadcrumbs from "../components/Common/CustomBreadcrumbs";
import { colors } from "../theme/theme";
import {
  MenuOutlined,
  NotificationsNoneOutlined,
  PlaceOutlined,
  RedeemOutlined,
} from "@mui/icons-material";
import { CustomBtn } from "../components/Common/CustomBtn";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Appbar = ({
  heading,
  btnText,
  onCreate,
  toggleSidebar,
  noBtn = false,
}) => {
  const { userData } = useSelector((state) => state.user);
  const location = useLocation();
  const path = location.pathname.split("/").slice(1).join(" > ");
  const isHomePage = path === "dashboard";

  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        {smScreen && (
          <IconButton onClick={toggleSidebar}>
            <MenuOutlined sx={{ color: "#fff", fontSize: "24px" }} />
          </IconButton>
        )}
        <Stack direction="column">
          <Typography
            sx={{
              fontFamily: "Mulish-Bold",
              fontSize: {
                sm: "24px",
                md: "32px",
              },
              color: "#fff",
            }}
          >
            {heading}
          </Typography>
          <CustomBreadcrumbs />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={smScreen ? 1 : 2} alignItems="center">
        <Box
          sx={{
            border: `1px solid ${colors.secondary}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "500px",
            p: smScreen ? 0.5 : 1,
            gap: 0.5,
          }}
        >
          {isHomePage ? (
            <PlaceOutlined sx={{ color: colors.secondary, fontSize: "16px" }} />
          ) : (
            <RedeemOutlined
              sx={{ color: colors.secondary, fontSize: "16px" }}
            />
          )}
          <Typography
            sx={{
              fontFamily: "Mulish-Regular",
              fontSize: smScreen ? "10px" : "12px",
              color: "#fff",
            }}
          >
            {isHomePage
              ? "Los Angeles, CA, USA"
              : `Earned ${userData?.points}pt`}
          </Typography>
        </Box>
        <IconButton>
          <Badge
            badgeContent={4}
            componentsProps={{
              badge: {
                sx: {
                  backgroundColor: colors.secondary,
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            }}
          >
            <NotificationsNoneOutlined
              sx={{
                color: "#fff",
                fontSize: "24px",
              }}
            />
          </Badge>
        </IconButton>
        {!smScreen && !noBtn && (
          <CustomBtn
            text={btnText || "Create New"}
            icon={true}
            width="180px"
            height="45px"
            fontSize="16px"
            onClick={onCreate || (() => {})}
          />
        )}
      </Stack>
    </Box>
  );
};

export default Appbar;
